<template>
  <div id="app">
    <div>
      <app-header></app-header>
      <app-autocomplete></app-autocomplete>
      <app-filter></app-filter>
      <app-navigation></app-navigation>
    </div>
    <app-contents></app-contents>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Autocomplete from "@/components/Autocomplete.vue";
import Navigation from "@/components/Navigation.vue";
import Contents from "@/components/Contents.vue";
import Filter from "@/components/Filter.vue";

export default {
  components: {
    appHeader: Header,
    appAutocomplete: Autocomplete,
    appNavigation: Navigation,
    appContents: Contents,
    appFilter: Filter
  }
};
</script>

<style>
@import "./assets/css/style.css";
</style>
